module.exports = __webpack_public_path__ + "img/delano4.875a6994.jpg";